var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, "min-width": 200, fixed: false, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _vm.edit
              ? _c(
                  "el-select",
                  {
                    model: {
                      value: scope.row[_vm.code],
                      callback: function ($$v) {
                        _vm.$set(scope.row, _vm.code, $$v)
                      },
                      expression: "scope.row[code]",
                    },
                  },
                  _vm._l(_vm.options, function (option) {
                    return _c("el-option", {
                      key: option[_vm.keyField],
                      attrs: {
                        value: option[_vm.keyField],
                        label: option[_vm.valueField],
                      },
                    })
                  }),
                  1
                )
              : _c("ik-table-check-tag", {
                  attrs: {
                    "default-value": _vm.defaultValue,
                    value: scope.row[_vm.code],
                    "key-field": _vm.keyField,
                    "value-field": _vm.valueField,
                    options: _vm.options,
                  },
                }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }